/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const MtgAppLecteur = require('./MtgAppLecteur')
const kernel = require('./kernel/kernel')
const DataInputStream = require('./entreesSorties/DataInputStream')
const DataOutputStream = require('./entreesSorties/DataOutputStream')
require('../css/mtgApp.css')
// cet objet sera exporté dans www/mtg32jsmin.js, sous la var globale mtg32
// par webpack.config.player.js (lancé via npm run build-player)
module.exports = {
  // c'est un constructeur en minuscule, mais ça reste comme ça
  // pour garder une compatibilité ascendante
  mtg32App: MtgAppLecteur,
  // Transféré ici depuis kernel. Doit être gardé tel quel car utilisé par le player des manuels
  /**
   * Renvoie les dimensions d'une figure où chdoc est la chaîne Base64 décivant la figure.
   * @param {type} chdoc
   * @returns {Object}
   */
  getDimensions: function getDimensions (chdoc) {
    var numeroVersion, natImageFond, nombreItems;
    var ba = kernel.base64Decode(chdoc);
    var inps = new DataInputStream(ba);
    // On saute les 17 premiers octets qui contiennent une chaine
    inps.skip(16);
    numeroVersion = inps.readInt();
    // Ligne suivante pour corriger un oubli dans la première version où le numéro de document
    // était nul
    if (numeroVersion === 0) numeroVersion = 5;
    if (numeroVersion > DataInputStream.numeroVersionActif) { // Amélioré version 4.4
      throw new Error("IOException");
    }
    if (numeroVersion >= 6) inps.readFloat();
    inps.readUTF(); // la langue dans laquelle a été créé le document
    inps.skip(5);
    natImageFond = inps.readByte();
    if (natImageFond !== DataOutputStream.nat_noImage) {
      inps.readBufferedImage();
      if (numeroVersion > 10) {
        inps.readInt();
        inps.readInt();
      }
    }
    // On lit un booléen indiquant si les codes d'items de menu correspondent à
    // des items interdits ou non
    inps.readBoolean();
    // On charge l'éventuelle liste d'items de menus
    nombreItems = inps.readInt();
    if (nombreItems !== 0) {
      for (var i = 0; i < nombreItems; i++) {
        inps.readInt();
      }
    }
    if (numeroVersion < 15) {
      inps.readUTF();
      inps.skip(5);
    }
    inps.readUTF();
    var ob = {};
    ob.x = inps.readInt();
    ob.y = inps.readInt();
    return ob;
  }
}



// WEBPACK FOOTER //
// ./src/mtg32.js